var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c4a91359cfec8abbea141696b31f500d6d900eff"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-main@flipgive"]={id:"c4a91359cfec8abbea141696b31f500d6d900eff"};
      